import AchievementComponent from "../../component/achievement_component";

const Achievement = ({ achievements }) => {
    return (
        <div className="achievement">
            <div className="achievement-header">
                Achievement
            </div>
            <div className="badges-content-card">
                {
                    achievements.map((achivement, index) => (
                        <AchievementComponent key={index} achivement={achivement} />
                    ))
                }
                
            </div>
        </div>
    )
}

export default Achievement;